import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const routes = [
  {
    path: '/',
    name: 'DownloadApp',
    component: () => import('@/view/download/downloadApp')
  },
  {
    path: '/downloadApp_1',
    name: 'DownloadApp1',
    component: () => import('@/view/download/downloadApp_1')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/view/agreement/privacy')
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('@/view/agreement/service')
  },
  {
    path: '/SDKContents',
    name: 'SDKContents',
    component: () => import('@/view/sdk/sdkContents')
  },
  {
    path: '/service-energy',
    name: 'ServiceEnergy',
    component: () => import('@/view/agreement/service-energy')
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('@/view/share/article')
  },
  {
    path: '/gift',
    name: 'Gift',
    component: () => import('@/view/share/gift')
  },
  {
    path: '/smallVideo',
    name: 'SmallVideo',
    component: () => import('@/view/share/smallVideo')
  },
  {
    path: '/powerMarket',
    name: 'PowerMarket',
    component: () => import('@/view/share/powerMarket')
  },
  {
    path: '/payKfcOrder',
    name: 'PayOrder',
    component: () => import('@/view/payOrder/index')
  },
  {
    path: '/merchantPoster',
    name: 'MerchantPoster',
    component: () => import('@/view/webview/merchantPoster')
  },
  {
    path: '/merchantPoster1',
    name: 'MerchantPoster1',
    component: () => import('@/view/webview/merchantPoster1')
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})


export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js